module.exports = __webpack_public_path__ + "img/marketing-target-dark.477d61ca.svg";